"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DetailedIconMixin = void 0;
var _styledComponents = require("styled-components");
var _styledToken = _interopRequireDefault(require("styled-token"));
var _inlineMediaQueryMixin = require("../inlineMediaQueryMixin");
var _mediaQueryMixin = require("../mediaQueryMixin");
var _spacingMixin = require("../spacingMixin");
var sizeCSS = (0, _inlineMediaQueryMixin.inlineMediaQueryMixin)('size', function (mediaProps) {
  return (0, _styledToken.default)('icons.sizes', function (iconSizes) {
    var size = mediaProps.size;
    if (iconSizes && iconSizes[size]) {
      var iconSize = iconSizes[size] + "px";
      return "\n                height: " + iconSize + ";\n                width: " + iconSize + ";\n            ";
    }
    return '';
  })(mediaProps);
});
var coloringCSS = function coloringCSS(props) {
  var status = props.status;
  return (0, _styledToken.default)({
    secondaryColor: "DetailedIcon." + status + ".secondaryColor",
    foregroundColor: "DetailedIcon." + status + ".foregroundColor",
    accentColor: "DetailedIcon." + status + ".accentColor",
    noFill: "DetailedIcon.noFill"
  }, function (_ref) {
    var secondaryColor = _ref.secondaryColor,
      foregroundColor = _ref.foregroundColor,
      accentColor = _ref.accentColor,
      noFill = _ref.noFill;
    return (0, _styledComponents.css)([".DetailedIcon__secondary-color-fill{fill:", ";}.DetailedIcon__foreground-color-fill{fill:", ";}.DetailedIcon__accent-color-fill{fill:", ";}.DetailedIcon__no-fill{fill:", ";}"], secondaryColor, foregroundColor, accentColor, noFill);
  })(props);
};

/** @class DetailedIconMixin */
/** @method */
var DetailedIconMixin = function DetailedIconMixin(props) {
  return (0, _styledToken.default)('DetailedIcon.defaultSize', function (defaultSize) {
    if (defaultSize === void 0) {
      defaultSize = 44;
    }
    return (0, _styledComponents.css)(["display:inline-block;vertical-align:top;", " height:", "px;width:", "px;", " ", " ", ""], (0, _spacingMixin.spacingMixin)(props), defaultSize, defaultSize, coloringCSS(props), sizeCSS(props), (0, _mediaQueryMixin.mediaQueryMixin)(function (mediaProps) {
      return sizeCSS(Object.assign({}, props, mediaProps));
    }));
  })(props);
};
exports.DetailedIconMixin = DetailedIconMixin;